import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e07276a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-navigation" }
const _hoisted_2 = { class: "page-navigation-index" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-navigation-dots" }, "…", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-navigation-dots" }, "…", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonIcon, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.index--)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.index--), ["prevent"]), ["space","enter"])),
      disabled: _ctx.index === 0,
      class: "page-navigation-prev",
      icon: "pagination-prev",
      styled: "is-normal",
      "aria-label": _ctx.$t('label.previousPage')
    }, null, 8, ["disabled", "aria-label"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.start > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_AppButton, {
              key: "start",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.index = 0)),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.index = 0), ["prevent"]), ["space","enter"])),
              onKeypress: _cache[4] || (_cache[4] = ()=>{}),
              class: "page-navigation-start",
              id: `page-navigation-index-${_ctx.items[0]}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.items[0]), 1)
              ]),
              _: 1
            }, 8, ["id"]),
            _hoisted_3
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineup, (item, i) => {
        return (_openBlock(), _createBlock(_component_AppButton, {
          key: item,
          onClick: ($event: any) => (_ctx.index = i + _ctx.start),
          onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.index = i + _ctx.start), ["prevent"]), ["space","enter"]),
          onKeypress: _cache[5] || (_cache[5] = ()=>{}),
          class: _normalizeClass({current: _ctx.index - _ctx.start === i}),
          id: `page-navigation-index-${item}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "onKeydown", "class", "id"]))
      }), 128)),
      (_ctx.end < _ctx.items.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createVNode(_component_AppButton, {
              key: "end",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.index = _ctx.items.length - 1)),
              onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.index = _ctx.items.length - 1), ["prevent"]), ["space","enter"])),
              onKeypress: _cache[8] || (_cache[8] = ()=>{}),
              class: "page-navigation-end",
              id: `page-navigation-index-${_ctx.items[_ctx.items.length - 1]}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.items[_ctx.items.length - 1]), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ButtonIcon, {
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.index++)),
      onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.index++), ["prevent"]), ["space","enter"])),
      disabled: _ctx.index === _ctx.items.length - 1,
      class: "page-navigation-next",
      icon: "pagination-next",
      styled: "is-normal",
      "aria-label": _ctx.$t('label.nextPage')
    }, null, 8, ["disabled", "aria-label"])
  ]))
}